<template>
  <v-container fluid class="d-flex align-center justify-center">
    <v-layout class="d-flex align-center justify-center">
      <div class="wid-100">
        <v-row dense align="center">
          <v-col cols="12">
            <div class="f-r pl-1">
              <v-btn
                small
                color="green lighten-2"
                class="white--text"
                @click="addBtnClicked"
              >북박스 추가</v-btn>
            </div>
            <div class="f-r">
              <v-btn
                small
                color="red lighten-2"
                class="white--text"
                @click="deleteBtnClicked"
              >선택 삭제</v-btn>
            </div>
          </v-col>

          <v-col cols="12" v-for="item in boxList" :key="item.odr">
            <v-row dense align="center">

              <v-col cols="12">
                <v-checkbox
                  v-model="item.select_yn"
                  :label=item.box_no
                  hide-details
                  dense
                ></v-checkbox>
                <!-- <h3>북박스 1</h3> -->
              </v-col>
              <v-col cols="12"><v-divider></v-divider></v-col>
              <v-col cols="2" >
                <div class="pt-0">
                  <span>북박스 노출</span>
                </div>
              </v-col>
              <v-col cols="10" class="pb-3">
                <v-checkbox
                  v-model="item.disp_yn_scr"
                  label="노출함"
                  hide-details
                  dense
                  @change="listItemChanged(item)"
                ></v-checkbox>
              </v-col>
              <!-- <v-col cols="12"><v-divider></v-divider></v-col> -->
              <!-- <v-col cols="2" ></v-col>
              <v-col cols="10">
                <v-checkbox
                  v-model="item.sbmt_sys_link_use_yn"
                  hide-details
                  dense
                  label="북박스 투고시스템 링크 활성화"
                  @change="listItemChanged(item)"
                ></v-checkbox>
              </v-col> -->
              <v-col cols="12"><v-divider></v-divider></v-col>
              <v-col cols="2" >
                <div class="pt-1">
                  <span>북박스 이미지</span>
                </div>
              </v-col>
              <v-col cols="2">
                <div class="wid-100 pt-1">
                  <v-file-input
                    v-model="item.bookImgSelectedFile"
                    placeholder="File input"
                    hide-details
                    dense
                    @change="listItemChanged(item)"
                  ></v-file-input>
                </div>
              </v-col>
              <v-col cols="3" v-if="item.book_img_orgnl_file_nm">
                <div class="wid-100 pt-0">
                  <div class="f-l pt-2 pl-5 font-1" style="color:white;">
                    <span><a :href="item.book_img_path">{{item.book_img_orgnl_file_nm}}</a></span>
                  </div>
                  <v-btn
                    small
                    color="red lighten-2"
                    class="pa-0 ma-0 white--text f-r"
                    hide-details
                    @click="deleteImgBtnClicked(item.odr, item.book_img_path, item.book_img_atch_sno)"
                    >삭제</v-btn>
                </div>
              </v-col>
              <!-- <v-col cols="7" >
                <div class="">
                  <v-btn
                    small
                    color="red lighten-2"
                    class="white--text"
                  >삭제</v-btn>
                </div>
              </v-col> -->
              <v-col cols="12"><v-divider></v-divider></v-col>
              <v-col cols="2" >
                <div class="pt-0">
                  <span>북박스 텍스트</span>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="wid-100">
                  <v-textarea
                    v-model="item.book_text"
                    class="wid-100 pt-0 pr-0"
                    hide-details
                    outlined
                    @change="listItemChanged(item)"
                  ></v-textarea>
                </div>
              </v-col>
              <v-col cols="12"><v-divider></v-divider></v-col>
              <v-col cols="2" >
                <div class="pt-0">
                  <span>북박스 최신호 URL</span>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="wid-100">
                  <v-text-field
                    v-model="item.book_newst_url"
                    class="wid-100 pt-0 pr-0"
                    hide-details
                    outlined
                    @change="listItemChanged(item)"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="7">
                <v-checkbox
                  v-model="item.book_newst_url_mber_only_yn_scr"
                  hide-details
                  dense
                  label="회원전용"
                  @change="listItemChanged(item)"
                ></v-checkbox>
              </v-col>
              <v-col cols="12"><v-divider></v-divider></v-col>
              <!-- <v-col cols="2" >
                <div class="pt-0">
                  <span>북박스 최신호 URL(회원전용)</span>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="wid-100">
                  <v-text-field
                    v-model="item.book_newst_url_mber_only"
                    class="wid-100 pt-0 pr-0"
                    hide-details
                    outlined
                    @change="listItemChanged(item)"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12"><v-divider></v-divider></v-col> -->
              <v-col cols="2" >
                <div class="pt-0">
                  <span>북박스 투고시스템 URL</span>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="wid-100 f-l">
                  <v-text-field
                    v-model="item.sbmt_sys_url"
                    class="wid-100 pt-0 pr-0"
                    hide-details
                    outlined
                    @change="listItemChanged(item)"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="7">
                <v-checkbox
                  v-model="item.sbmt_sys_link_use_yn_scr"
                  hide-details
                  dense
                  label="북박스 투고시스템 링크 활성화"
                  @change="listItemChanged(item)"
                ></v-checkbox>
              </v-col>
              <!-- <v-col cols="3">
                <span>현재: &nbsp; www.test.com</span>
              </v-col> -->
              <v-col cols="12"><v-divider></v-divider></v-col>
            </v-row>
          </v-col>
        </v-row>  
      </div>
    </v-layout>
  </v-container> 
</template>

<script>
export default {
  data(){
    return{
      boxList: [],
      changedList: [],
    }
  },
  created() {
    this.mberSno = this.$session.get("mberSno");

    this.getSoctyBookBoxList();
  },
  methods: {
    // 북박스 수정됨
    listItemChanged(item) {
      this.itemChanged();
      console.log("listItemChanged: ", item);
      // 추가된 목록인 경우 -> [추가] 시 changedList에도 추가함
      if(item.socty_sno == null || item.socty_sno == "") {
        return;
      }

      let found = false;
      this.changedList.forEach((e) => {
        if(e.socty_sno == item.socty_sno && e.odr == item.odr) {
          found = true;
        }
      });

      if(!found) {
        this.changedList.push(item);
      }
    },
    getSoctyBookBoxList() {
      this.$http.get("/admin/getSoctyBookBoxList").then((res) => {
        // console.log("res.data.result:", res.data.result);
        res.data.result.boxList.forEach((e, i) => {
          e.select_yn = false;
          e.sbmt_sys_link_use_yn_scr = e.sbmt_sys_link_use_yn == 'Y' ? true : false;
          e.book_newst_url_mber_only_yn_scr = e.book_newst_url_mber_only_yn == 'Y' ? true : false;
          e.disp_yn_scr = e.disp_yn == 'Y' ? true : false;
          e.idx = i + 1;
          e.box_no = "북박스 " + e.idx;
        });

        this.boxList = JSON.parse(JSON.stringify(res.data.result.boxList));
        // console.log("boxList:", this.boxList);
        this.changedList = [];
      }).catch(
        function (error) {
          console.log(error);
        }
      )
    },
    deleteBtnClicked() {
      console.log("deleteSoctyBookBox");

      // 선택 체크된 목록 확인 -> deleteList 에 추가
      let deleteList = [];
      let isSelected = false;

      // for(let i = 0; i < this.boxList.length; i++) {
      //   if(this.boxList[i].select_yn) {
      //     isSelected = true;

      //     if(!this.boxList[i].new_yn) {
      //       deleteList.push(this.boxList[i]);
      //     }
      //   }
      // }
      deleteList = this.boxList.filter((e) => {
        if(e.select_yn) isSelected = true;
        return e.select_yn && !e.new_yn;
      });

      // 데이터 검증
      // deleteList.forEach((e) => {
      //   console.log("deleteList:", e);
      // });

      // 선택된 항목이 없는 경우
      if(!isSelected) {
        alert("선택된 목록이 없습니다.");
        return;
      }

      if(confirm("삭제 후 목록을 다시 조회합니다.\n삭제하시겠습니까?")) {
        if(deleteList.length > 0) {
          let params = new URLSearchParams();
          
          params.append("deleteList", JSON.stringify(deleteList));

          this.$http.post("/admin/deleteSoctyBookBoxList", params).then((res) => {
            console.log(res.data);
            alert("삭제되었습니다.");
            // this.getSoctyBookBoxList();
            this.boxList = this.boxList.filter((e) => {
              return !(e.select_yn);
            });

            this.changedList = this.changedList.filter((e) => {
              return !(e.select_yn);
            });
          })
          .catch(function (error) {
              console.log(error);
            }
          );
        } 
        // 추가된 객체만 선택된 경우
        else {
          // this.getSoctyBookBoxList();
          this.boxList = this.boxList.filter((e) => {
            return !(e.select_yn);
          });

          this.changedList = this.changedList.filter((e) => {
            return !(e.select_yn);
          });
        }
      }
    },
    addBtnClicked() {
      if(this.boxList.length >= 2) {
        alert("북박스는 2개까지 등록 가능합니다.");
        return;
      }

      let maxOdr = 0;
      let maxIdx = 0;

      this.boxList.forEach((e) => {
        if(e.odr > maxOdr) {
          maxOdr = e.odr;
        }

        if(e.idx > maxIdx) {
          maxIdx = e.idx;
        }
      });

      maxOdr++;
      maxIdx++;

      this.boxList.push({new_yn:true, select_yn:false, socty_sno:null, odr:maxOdr, idx:maxIdx, disp_yn_scr:false, sbmt_sys_link_use_yn_scr:false, box_no:"북박스 " + maxIdx,
                          book_text:null, book_newst_url:null, book_newst_url_mber_only_yn_scr:false, sbmt_sys_url:null,
                          book_img_atch_sno:null, book_img_path:null, book_img_orgnl_file_nm:null, bookImgSelectedFile: null});
      this.changedList.push(this.boxList[this.boxList.length - 1]);
    },
    saveBtnClicked() {
      console.log("saveSoctyBookBox");

      if(this.changedList.length == 0) {
        // alert("수정된 내용이 없습니다.");
        return;
      }

      const file_info_list = [];

      // if(confirm("저장하시겠습니까?")) {
        let params = new FormData();

        // const changedList = JSON.parse(JSON.stringify(this.changedList));

        // true/false -> 'Y'/'N' 변환
        this.changedList.forEach((e) => {
          e.new_yn = e.new_yn == true ? 'Y' : 'N';
          e.disp_yn = e.disp_yn_scr == true ? 'Y' : 'N';
          e.sbmt_sys_link_use_yn = e.sbmt_sys_link_use_yn_scr == true ? 'Y' : 'N';
          e.book_newst_url_mber_only_yn = e.book_newst_url_mber_only_yn_scr == true ? 'Y' : 'N';

          // 첨부 이미지
          if(e.bookImgSelectedFile != null) {
            console.log("file attached:", e.bookImgSelectedFile);
            params.append('file_list', e.bookImgSelectedFile);
            file_info_list.push({odr:e.odr});
          } 
        });

        params.append("mber_sno", this.mberSno);
        params.append("changedList", JSON.stringify(this.changedList));

        params.append("file_info_list", JSON.stringify(file_info_list));

        this.$http.post("/admin/upsertSoctyBookBoxList", params, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((res) => {
          console.log(res.data);
          // alert("저장되었습니다.");
          
          this.getSoctyBookBoxList();
        }).catch(function (error) {
            console.log(error);
        });
      // }
    },
    deleteImgBtnClicked(odr, filePath, fileAtchSno) {
      if(confirm("삭제하시겠습니까?")) {
        // console.log("filePath:", filePath);
        // console.log("atchSno:", fileAtchSno);
        
        if(filePath == null) {
          alert("삭제할 파일이 없습니다.");
          return;
        }

        const params = new FormData();

        params.append("mber_sno", this.mberSno);
        params.append("odr", odr);
        params.append("file_path", filePath);
        params.append("file_atch_sno", fileAtchSno);

        this.$http.post("/admin/deleteSoctyBookBoxFile", params).then((res) => {
          console.log(res.data);
          alert("삭제되었습니다.");
          
          this.getSoctyBookBoxList();
        })
        .catch(function (error) {
            console.log(error);
          }
        );
      }
    },
    itemChanged() {
      console.log("itemChanged");
      this.$emit('tabChanged', 'bookBoxTab');
    },
  }
}
</script>

<style>

</style>